// reducers.js
import {
    CLEAR_PRODUCT_LIST,
    FETCH_PRODUCT_LIST,SET_PRODUCT_LIST
} from '../actions';
const initialState = {
    productData: null,
    isLoading: false,
    error: null,
};

const productListReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_PRODUCT_LIST:
            return {
                ...state,
            };

        case SET_PRODUCT_LIST:
            return {
                ...state,
                productData: action.payload,
                isLoading: false,
            };

        case CLEAR_PRODUCT_LIST:
            return {
                ...state,
                productData: null,
            };

        default:
            return state;
    }
};

export default productListReducer;
